const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'axelar',
            client_id: '07-tendermint-225',
            connection_id: 'connection-210'
        },
        chain_2: {
            chain_name: 'lava',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-156',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cosmoshub',
            client_id: '07-tendermint-1318',
            connection_id: 'connection-1050'
        },
        chain_2: {
            chain_name: 'lava',
            client_id: '07-tendermint-7',
            connection_id: 'connection-12'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-969',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-6',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'lava',
            client_id: '07-tendermint-1',
            connection_id: 'connection-1'
        },
        chain_2: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3210',
            connection_id: 'connection-2668'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-76971',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'lava',
            client_id: '07-tendermint-8',
            connection_id: 'connection-13'
        },
        chain_2: {
            chain_name: 'stargaze',
            client_id: '07-tendermint-366',
            connection_id: 'connection-307'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-7',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-391',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
